module.exports = __webpack_public_path__ + "media/home/digitizedImagesAccess-x2-36769fc2.png";